import React from "react";
import CustomTab from "../../components/ui/CustomTab";

const tabs = [
	{
		label: "At-a-glance",
		to: "at-a-glance",
		value: "/dashboard/at-a-glance",
	},
	{
		label: "Quota - Next Period",
		to: "quota-next-period",
		value: "/dashboard/quota-next-period",
	},
	{
		label: "Quota - Running Period",
		to: "quota-running-period",
		value: "/dashboard/quota-running-period",
	},

];

const Dashboard = () => {
	return <CustomTab tabs={tabs} />;
};

export default Dashboard;
